<template>
  <div id="app">
    <router-view v-if="isLoginPage" />
    <el-container v-else class="layout">
      <el-aside width="220px" class="sidebar">
        <div class="logo">
          <div class="logo-main">ACAA</div>
          <div class="logo-sub">证书管理后台</div>
        </div>
        <el-menu
          :default-active="activeMenu"
          background-color="#1f2d3d"
          text-color="#bfcbd9"
          active-text-color="#ff8c4e"
          router
        >
          <el-submenu index="nav">
            <template slot="title">
              <i class="el-icon-s-management"></i>
              <span>业务管理</span>
            </template>
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/artists">鉴别艺人</el-menu-item>
            <el-menu-item index="/certificates">证书档案</el-menu-item>
            <el-menu-item index="/query-logs">查询记录</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="header">
          <span class="welcome">
            欢迎使用 ACAA 证书管理后台
          </span>
          <div class="user-actions">
            <span class="nickname">{{ displayName }}</span>
            <el-button type="text" @click="logout">退出登录</el-button>
          </div>
        </el-header>
        <el-main class="main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'AccaAdminApp',
  computed: {
    isLoginPage() {
      return this.$route.path === '/login'
    },
    activeMenu() {
      return this.$route.path === '/' ? '/' : this.$route.path
    },
    displayName() {
      const u = this.$store.state.userInfo
      return u && (u.nickname || u.username) ? u.nickname || u.username : '管理员'
    }
  },
  methods: {
    logout() {
      this.$store.commit('clearAuth')
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  min-height: 100vh;
}

.sidebar {
  background-color: #1f2d3d;

  .logo {
    min-height: 60px;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .logo-main {
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.08em;
  }

  .logo-sub {
    margin-top: 6px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.65);
  }
}

.header {
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  padding: 10px 20px;
}

.welcome {
  font-size: 14px;
  color: #606266;
}

.main {
  background: #f5f7fa;
  padding: 16px 20px 24px;
}

.user-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nickname {
  color: #606266;
  font-size: 14px;
}
</style>
